/* src/app/sections/tabs-section/tabs-section.component.css */
/*# sourceMappingURL=tabs-section.component.css.map */
